import { DocumentBuilder as n } from "./document-builder.js";
import { BlockParser as l } from "./block-parser.js";
class u {
  schema;
  constructor(o) {
    this.schema = o;
  }
  parse(o, s) {
    const r = new n(this.schema), e = new l(r, s), c = o.blocks;
    return c.forEach((t, a) => {
      e.handle(t, c[a + 1]);
    }), r.doc;
  }
}
export {
  u as BlocksParser
};
